import { cx } from "@/lib/tailwind-utils";

export function EnterpriseTag({ className }: { className?: string }) {
  return (
    <span
      className={cx(
        "shrink-0 rounded bg-primary/15 px-1.5 py-0.5 text-caption text-primary",
        className,
      )}
    >
      Enterprise
    </span>
  );
}
